import { staticText } from 'utils/staticText';

export const EmailTypoSuggestionStaticText = staticText({
  emailTypoSuggestion: {
    _: 'Did you mean ${suggestedEmail}?',
    zh: '你是否想輸入 ${suggestedEmail}？',
  },
});
